import React from "react";
import { useFetch } from "../hooks/UseFetch";
import SideNav from "./page-essential/SideNav";

const Home = () => {
  const { loading, errMsg, data } = useFetch(
    "https://jsonplaceholder.typicode.com/todos/1"
  );
  console.log(data);
  return (
    <div>
      <SideNav>
        <div>Home</div>
      </SideNav>
    </div>
  );
};

export default Home;
